import React, { Component } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css';
import 'antd/dist/antd.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faList,
  faStroopwafel,
  faTh,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import { Route, Switch, withRouter } from 'react-router-dom';
import StartProject from './containers/startproj/start_proj';
import IndevelopProject from './containers/startproj/DevelopTabs/indev_project';
import ReleaseProject from './containers/releaseproj/ReleaseProject';
import ActiveProject from './containers/startproj/ActiveProject';
import ClosedProject from './containers/startproj/ClosedProject';
import CommToolProvider from './containers/common/comm_tool_provider';
import HeaderNav from './containers/HeaderNav/navigation';
import './components/TabsRoutes/styles.css';
import './components/TabsState/styles.css';
import './components/ConfirmationDialog/styles.css';
import './components/TaskList/styles.css';
import BrowserDetection from 'react-browser-detection';
import DataProject from 'containers/startproj/DataTrackTabs/datatrack_project';
import FMPProject from 'containers/startproj/FMPTrackTabs/fmptrack_project';
import AddIPSProject from 'containers/startproj/AddNewIpsProject';
import Admin from "./containers/Dashboard/Admin";
 import { LoginCallback,useOktaAuth } from '@okta/okta-react';
import AuthenticationWrapper from 'components/Authenticator/AuthenticationWrapper';

library.add(faStroopwafel);
library.add(faList);
library.add(faTh);
library.add(faTimesCircle);

const browserHandler = {
  ie: () => (
    <div className='ieWarning'>
      WARNING: Some Checklist App functionality is unavailable in Internet
      Explorer. Please close this window and re-open the Checklist in an
      approved web browser (Chrome, Firefox, Safari, or AirWatch Web).
    </div>
  ),
  default: () => <div />,
};

class App extends Component {
  render() {
  // Define this inside or outside render, but ensure it's a clean object
  const browserHandler = {
    ie: () => (
      <div className='ieWarning'>
        WARNING: Some Checklist App functionality is unavailable in Internet Explorer.
      </div>
    ),
    default: () => <div />,
  };

  return (
    <Switch>
      {/* 1. OKTA CALLBACK - Outside everything */}
      <Route path='/callback' component={LoginCallback} />

      {/* 2. PROTECTED APP */}
      <Route render={() => (


<CommToolProvider>
  <AuthenticationWrapper>
    <Switch>
      <Route exact path='/dashboard/Admin' component={Admin} />
          <Route exact path='/dashboard/:tabId' component={StartProject} />
          <Route
            exact
            path='/dashboard/:tabId/search'
            component={StartProject}
          />
          <Route
            path='/development/:projectId/:tabId?'
            component={IndevelopProject}
          />
          <Route path='/active/:projectId/:tabId?' component={ActiveProject} />
          <Route
            path='/release/:projectId/:tabId?'
            component={ReleaseProject}
          />
          <Route path='/closed/:projectId/:tabId?' component={ClosedProject} />
          <Route
            path='/datatracker_hold/:station_name/:bpid/:workOrder/:tabId?'
            component={DataProject}
          />
          <Route
            path='/datatracker_progress/:station_name/:bpid/:workOrder/:tabId?'
            component={DataProject}
          />
          <Route exact path='/' component={StartProject} />
          <Route
            path='/datatracker_complete/:station_name/:bpid/:workOrder/:tabId?'
            component={DataProject}
          />
          <Route exact path="/ipsdatatracker/newproject" component={AddIPSProject} />
          <Route exact path='/' component={StartProject} />
           <Route
            path='/fmptracker_progress/:station_name/:bpid/:workOrder/:tabId?'
            component={FMPProject}
          />
          <Route
            path='/fmptracker_review/:station_name/:bpid/:workOrder/:tabId?'
            component={FMPProject}
          />
          <Route
            path='/fmptracker_asbuilts/:station_name/:bpid/:workOrder/:tabId?'
            component={FMPProject}
          />
          <Route exact path='/' component={StartProject} />
          <Route
            path='/fmptracker_complete/:station_name/:bpid/:workOrder/:tabId?'
            component={FMPProject}
          />
      <Route render={({location}) =>(
        <h2>Route not found</h2>
      )} />
    </Switch>
  </AuthenticationWrapper>
</CommToolProvider>

        // <AuthenticationWrapper>
        //   <CommToolProvider>
        //     {/* Fix: Pass the object directly to BrowserDetection */}
        //     <BrowserDetection>
        //      {browserHandler}
        //     </BrowserDetection>


        //     <Switch>
        //       <Route exact path='/dashboard/:tabId' component={StartProject} />
        //       {/* <Route exact path='/dashboard/Admin' component={Admin} />
              
        //       <Route exact path='/dashboard/:tabId/search' component={StartProject} />
        //       <Route path='/development/:projectId/:tabId?' component={IndevelopProject} />
        //       <Route path='/active/:projectId/:tabId?' component={ActiveProject} />
        //       <Route path='/release/:projectId/:tabId?' component={ReleaseProject} />
        //       <Route path='/closed/:projectId/:tabId?' component={ClosedProject} />
        //       <Route path='/datatracker_hold/:station_name/:bpid/:workOrder/:tabId?' component={DataProject} />
        //       <Route path='/datatracker_progress/:station_name/:bpid/:workOrder/:tabId?' component={DataProject} />
        //       <Route path='/datatracker_complete/:station_name/:bpid/:workOrder/:tabId?' component={DataProject} />
        //       <Route exact path="/ipsdatatracker/newproject" component={AddIPSProject} /> */}
        //       <Route exact path='/' component={StartProject} />
        //     </Switch>
        //   </CommToolProvider>
        // </AuthenticationWrapper>
      )} />
    </Switch>
  );
}
}

export default withRouter(App);